import { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import {
  createGetBannerEnrichmentsModel,
  fetchGetBannerEnrichments,
  type TGetBannerEnrichmentsRequest,
  type TGetBannerEnrichmentsResponse,
} from 'shared/repositories/ad-banner/v1/get-banner-enrichments';
import { IApplicationContext } from 'shared/types/applicationContext';
import { IGetBannerEnrichmentsV1Response } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/GetBannerEnrichmentsV1Response';

export async function fetchGetBannerEnrichmentsService(
  applicationContext: IApplicationContext,
  parameters: TGetBannerEnrichmentsRequest,
): Promise<IGetBannerEnrichmentsV1Response> {
  const { httpApi, logger } = applicationContext;

  const domain = 'src/shared/services/fetchGetBannerEnrichmentsService.ts';

  return fetchGetBannerEnrichments<TGetBannerEnrichmentsResponse, TGetBannerEnrichmentsResponse>({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400: {
          const httpBadStatusCodeError = new HttpBadStatusCodeError({
            details: {
              model: JSON.stringify(createGetBannerEnrichmentsModel(parameters)),
            },
            domain,
            message: `Ошибка в запросе: ${result.response?.message}`,
            statusCode,
          });

          logger.warning(httpBadStatusCodeError.message, {
            details: httpBadStatusCodeError.printDetails(),
            domain: httpBadStatusCodeError.domain,
          });

          throw httpBadStatusCodeError;
        }
        default: {
          const httpBadStatusCodeError = new HttpBadStatusCodeError({
            details: {
              model: JSON.stringify(createGetBannerEnrichmentsModel(parameters)),
            },
            domain,
            message: `Неизвестный статус ответа: ${statusCode}`,
            statusCode,
          });

          logger.error(httpBadStatusCodeError.message, {
            details: httpBadStatusCodeError.printDetails(),
            domain: httpBadStatusCodeError.domain,
          });

          throw httpBadStatusCodeError;
        }
      }
    },
    error => {
      const unknownError = new UnknownError({
        details: {
          model: JSON.stringify(createGetBannerEnrichmentsModel(parameters)),
        },
        domain,
        message: 'Неизвестная ошибка в запросе',
      });

      logger.error(error, {
        details: unknownError.printDetails(),
        domain: unknownError.domain,
        message: unknownError.message,
      });

      throw unknownError;
    },
  );
}
